module.exports = __webpack_public_path__ + "media/img/testimonial/chen-8dde0e03495d76ce5d2aea5b13bf52b1.jpeg";